<!--<h1 mat-dialog-title>Hi {{data.name}}</h1>-->
<div mat-dialog-content>

    <!--<div class="row item" [ngClass]="routeAnimationsElements">
        <div class="col-12">
            <div class="alert alert-info">
                <div>
                    SelectedCompany: {{SelectedCompany}}
                </div>
                <div>
                    SelectedOrganization: {{SelectedOrganization}}
                </div>
                <div>
                    SelectedAgent: {{SelectedAgent}}
                </div>
                <div>
                    SelectedClient: {{SelectedClient}}
                </div>
            </div>
        </div>
    </div>-->

    <div class="row">
        <div class="col-xs-12 col-md-12">
            <lus-company-select style="width:100%;" (OnCompanySelected)="selectCompany($event)"></lus-company-select>
        </div>
        <div class="col-xs-12 col-md-12">
            <lus-organization-search [SelectedCompany]="SelectedCompany" (OnOrganizationSelected)="OnOrganizationSelected($event)"></lus-organization-search>
        </div>
        <div class="col-xs-12 col-md-12">
            <lus-agent-search [SelectedCompany]="SelectedCompany" [SelectedOrganization]="SelectedOrganization" (OnAgentSelected)="selectAgent($event)"></lus-agent-search>
        </div>
        <div class="col-xs-12 col-md-12">
            <lus-client-search [SelectedAgent]="SelectedAgent" [SelectedCompany]="SelectedCompany" [SelectedOrganization]="SelectedOrganization" (OnClientDTOSelected)="selectClient($event)"></lus-client-search>
        </div>
    </div>

    <div class="Vert-50"></div>

</div>


<div mat-dialog-actions>
    <button mat-button (click)="OnCancel()">Cancel</button>
    <button mat-button (click)="OnOK()" cdkFocusInitial>OK</button>
</div>

